import { EditPromo } from 'features/ManageCampaigns/EditPromoDialog/EditPromo'
import { useState } from 'react'

const MainPromo = ({
  promotionCode,
  setPromotionCode,
  minNightsToStay,
  setMinNightsToStay,
  maxDiscountPercentage,
  setMaxDiscountPercentage,
  setPromoTagline,
  promoTagline,
  hasPromoValidityDate,
  setHasPromoValidityDate,
  promoValidityStartDate,
  setPromoValidityStartDate,
  promoValidityEndDate,
  setPromoValidityEndDate
}) => {
  const [isUsingDiscount, setIsUsingDiscount] = useState(!!promotionCode)

  const isPromoValid = isUsingDiscount
    ? !!promotionCode?.match(/^[A-Za-z0-9]{1,15}$/gm)
    : true

  return (
    <div>
      <EditPromo
        promoCode={promotionCode}
        setPromoCode={setPromotionCode}
        minNights={minNightsToStay}
        setMinNights={setMinNightsToStay}
        maxDiscount={maxDiscountPercentage}
        setMaxDiscount={setMaxDiscountPercentage}
        setPromoTagline={setPromoTagline}
        promoTagline={promoTagline}
        hasPromoValidityDateControls={true}
        hasPromoValidityDate={hasPromoValidityDate}
        setHasPromoValidityDate={setHasPromoValidityDate}
        promoValidityStartDate={promoValidityStartDate}
        setPromoValidityStartDate={setPromoValidityStartDate}
        promoValidityEndDate={promoValidityEndDate}
        setPromoValidityEndDate={setPromoValidityEndDate}
        isUsingDiscount={isUsingDiscount}
        setIsUsingDiscount={setIsUsingDiscount}
        isPromoValid={isPromoValid}
      />
    </div>
  )
}

export default MainPromo
